export function isUriAsset(options) {
    return !!options && 'uri' in options;
}
export function isFileAsset(options) {
    return !!options && 'file' in options;
}
export function isAssetFromData(options) {
    return 'assetData' in options;
}
export function isDerivedAsset(options) {
    return 'parentAsset' in options;
}
export function isFileUploadParams(options) {
    return 'file' in options;
}
export function isFetchSingleAssetByUrlParams(params) {
    return 'url' in params;
}
export function isFetchSingleAssetByMetadataParams(params) {
    return 'query' in params;
}
//# sourceMappingURL=typeGuards.js.map